import type { ReactNode } from 'react';

interface ParentPageHeaderProps {
  title: string;
  /** Optional controls aligned to the end of the header, e.g. tabs or a filter. */
  children?: ReactNode;
}

/**
 * The header card every parent page opens with.
 *
 * Matches the shape the student and teacher pages already use — see
 * `QuizzesHeader`, `AssignmentsHeader` and `GroupsHeader` — so the parent
 * environment reads as part of the same app rather than a bolt-on. Those are
 * each tied to their own filters, hence a separate component here rather than
 * an import.
 */
export default function ParentPageHeader(parentPageHeaderProps: ParentPageHeaderProps) {
  const { title, children } = parentPageHeaderProps;

  return (
    <div className={'border-border-primary bg-background flex w-full flex-col gap-3 rounded-2xl border p-4'}>
      <div className={'flex flex-col gap-3 sm:flex-row sm:items-center'}>
        <h2 className={'text-foreground text-xl font-semibold'}>{title}</h2>
        {children}
      </div>
    </div>
  );
}
